module.exports = __webpack_public_path__ + "img/kc12.b717a578.png";